import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
import { GLCodesBudgetByPeriodBudgets } from './useGlCodesBudgetByYearApi';

export interface GLCodeBudgetSaveRequest {
  id: number;
  code: string;
  description: string;
  isActive: boolean;
  isFixed: boolean;
  periodBudgets: GLCodesBudgetByPeriodBudgets[];
}

const useGLCodeBudgetSaveApi = (companyId: string) => {
  const call = useCallback(
    async (body?: GLCodeBudgetSaveRequest[]) => {
      try {
        const res = await axiosInstance.put(api.saveGLCode(companyId), body);
        return res.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    [companyId]
  );

  const { isLoading, execute } = useAsync(call, false, undefined);

  return {
    isLoading,
    saveGlCodeBudget: execute,
  };
};

export default useGLCodeBudgetSaveApi;
